import React from 'react';
import './LoadingSpinner.scss';
import { LoadingBar } from '../LoadingBar/LoadingBar';

interface IBaseLoadingSpinnerProps {
  message: string;
  gis?: boolean;
  className?: string;
}

export const BaseLoadingSpinner = (props: IBaseLoadingSpinnerProps) => {
  const { message, gis, className } = props;
  const srMessage = message ? message.replace(/\.{1,4}$/, '') : 'Loading';
  return (
    <div
      data-testid="loading-spinner"
      className={`${className ? className : ''} ${gis ? 'loading-spinner-gis' : 'loading-spinner'}`}
    >
      <div className="justify-content-center" aria-hidden={true}>
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        {message && message !== '' ? <h2>{message}</h2> : null}
      </div>
      <span className="usa-sr-only">{srMessage}</span>
    </div>
  );
};

interface IToolBarLoadingSpinnerProps {
  message: string;
  jobExecuting: boolean;
}

export const ToolBarLoadingSpinner = (props: IToolBarLoadingSpinnerProps) => {
  const { message, jobExecuting } = props;
  return (
    <div role="status">
      <div className="toolbar-row" hidden={!jobExecuting}>
        <div className="toolbar-message">
          <BaseLoadingSpinner message={message === undefined ? 'Loading...' : message} />
        </div>
      </div>
    </div>
  );
};

interface ILoadingSpinnerProps {
  message: string;
  loading: boolean;
  gis?: boolean;
  className?: string;
  outerClassName?: string;
}

export const LoadingSpinner = (props: ILoadingSpinnerProps) => {
  const { message, loading, gis, className, outerClassName } = props;
  return (
    <div role="status">
      <div className={`${outerClassName ? outerClassName : ''}`} hidden={!loading}>
        <BaseLoadingSpinner message={message} gis={gis} className={className} />
      </div>
      <span className="usa-sr-only" hidden={loading}>
        Content Loaded
      </span>
    </div>
  );
};

interface ILoaderProps {
  message?: string;
  className?: string;
}

export const Loader = (props: ILoaderProps) => {
  const { message, className } = props;
  return (
    <div role="status" className={`loader ${className}`} data-testid="loading-spinner">
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {message ? <div className="h3">{message}</div> : null}
    </div>
  );
};

interface ILoaderWithBarProps {
  message: string;
  className?: string;
  processName?: string;
  loadingProgress: number;
  loading: boolean;
}
export const LoaderWithBar = (props: ILoaderWithBarProps) => {
  const { message, className, loading, processName, loadingProgress } = props;
  const percentMax = 100;
  const cappedProgress = Math.min(Math.max(0, loadingProgress), percentMax);

  return (
    <div role="status" className={`loader ${className}`} data-testid="loading-spinner">
      {processName ? <h1 className="process-name h2">{processName}</h1> : null}
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {message && (
        <div className="loading-bar-wrapper">
          <LoadingBar jobExecuting={loading} progress={cappedProgress} processOccurring={message} />
        </div>
      )}
    </div>
  );
};